import { SvgIcon } from "@mui/material";
import { FC } from "react";

const AdminAiIcon: FC<{
  active?: boolean;
  size?: number;
}> = ({ size = 24 }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    aria-hidden="true"
    sx={{ fontSize: size, display: "block" }}
  >
    <circle
      cx="12"
      cy="12"
      r="2.35"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <circle
      cx="7.25"
      cy="8"
      r="1.65"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <circle
      cx="16.75"
      cy="8"
      r="1.65"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <circle
      cx="12"
      cy="16.85"
      r="1.65"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <path
      d="M8.7 9.3 10.55 10.6M15.3 9.3 13.45 10.6M12 14.35v.85"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.7"
    />
  </SvgIcon>
);

export default AdminAiIcon;
